import { sankeyColors } from '@/components/BudgetCalculator/sankeyColors';
import * as React from 'react';

import { CustomNodePayload } from '@/components/BudgetCalculator/CustomNode';

export type CustomLinkPayload = {
  source: CustomNodePayload;
  target: CustomNodePayload;
  value: number;
  color?: string;
  dy: number;
  sy: number;
  ty: number;
};

export const CustomLink = (props: {
  sourceX: number;
  targetX: number;
  sourceY: number;
  targetY: number;
  sourceControlX: number;
  targetControlX: number;
  sourceRelativeY: number;
  targetRelativeY: number;
  linkWidth: number;
  index: number;
  payload: CustomLinkPayload;
}) => {
  const minY = Math.min(props.sourceY, props.targetY) - props.linkWidth / 2;
  const maxY = Math.max(props.sourceY, props.targetY) + props.linkWidth / 2;
  const maskId = `mask-${props.index}`;
  return (
    <>
      <mask id={maskId}>
        <rect
          x={props.sourceX}
          y={minY}
          width={props.targetX - props.sourceX}
          height={maxY - minY}
          fill="white"
        />
      </mask>
      <g mask={`url(#${maskId})`}>
        <rect
          x={props.sourceX}
          y={minY}
          width={props.targetX - props.sourceX}
          height={maxY - minY}
          fill="transparent"
        />
        <path
          d={`
  M${props.sourceX},${props.sourceY}
  C${props.sourceControlX},${props.sourceY} ${props.targetControlX},${props.targetY} ${props.targetX},${props.targetY}`}
          fill="none"
          stroke={
            props.payload.color || sankeyColors[props.payload.source.depth % sankeyColors.length]
          }
          strokeWidth={props.linkWidth}
          strokeLinecap="butt"
        />
      </g>
    </>
  );
};
